import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { StatsBanner } from './components/StatsBanner';
import { Products } from './components/Products';
import { WhyUs } from './components/WhyUs';
import { Testimonials } from './components/Testimonials';
import { Newsletter } from './components/Newsletter';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen flex flex-col w-full bg-brand-bg font-body text-brand-charcoal selection:bg-brand-mint selection:text-brand-emerald" data-id="element-0">
      <Navbar data-id="element-1" />

      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <StatsBanner data-id="element-4" />
        <Products data-id="element-5" />
        <WhyUs data-id="element-6" />
        <Testimonials data-id="element-7" />
        <Newsletter data-id="element-8" />
        <FinalCTA data-id="element-9" />
      </main>

      <Footer data-id="element-10" />
    </div>;
}